"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TPS_REVIEW_FINISHED = exports.TPS_REVIEW_STARTED = exports.TPS_MAILED_USCIS_APPLICATION_AT = exports.TPS_INTERVIEW_FINISHED = exports.TPS_INTERVIEW_STARTED = void 0; // --- Milestones

exports.TPS_INTERVIEW_STARTED = "tpsInterviewStarted";
exports.TPS_INTERVIEW_FINISHED = "tpsInterviewFinished";
exports.TPS_MAILED_USCIS_APPLICATION_AT = "tpsMailedUscisApplication"; // --- Operational

exports.TPS_REVIEW_STARTED = "tpsReviewStarted";
exports.TPS_REVIEW_FINISHED = "tpsReviewFinished";